import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const help: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 43.45 43.45">
            <g id="Calque_1-2" data-name="Calque 1">
                <path fill={color} d="M21.64,13a2.08,2.08,0,0,0,2.25-2.17,2.1,2.1,0,0,0-2.17-2.21,2.16,2.16,0,0,0-2.21,2.21A2.1,2.1,0,0,0,21.64,13Z" />
                <rect fill={color} x="19.96" y="15.37" width="3.54" height="19.44" />
                <path fill={color} d="M21.72,0A21.71,21.71,0,0,0,7.62,38.22L9,36.94a19.88,19.88,0,1,1,1.5,1.14L9.1,39.38A21.72,21.72,0,1,0,21.72,0Z" />
            </g>
        </svg>
    );
};

export default help;
